import {Component, computed, input} from '@angular/core';
import {CurrencyPipe, UpperCasePipe} from '@angular/common';
import {IconsComponent} from '../../../../../../shared/components/icons/icons.component';
import {ItemImageComponent} from '../../../../../../shared/components/item-image/item-image.component';
import {CompareItemBase} from '../../../../compare-item.base';
import {ICompareItem} from '../../../../../../types/ICompareItem';

@Component({
  selector: 'app-compare-print-item',
  imports: [CurrencyPipe, IconsComponent, ItemImageComponent, UpperCasePipe],
  templateUrl: './compare-print-item.component.html',
  styleUrl: './compare-print-item.component.css',
})
export class ComparePrintItemComponent extends CompareItemBase {
  level = input.required<string>();
  item = input.required<ICompareItem>();

  borderColor = computed(() => ({good: 'border-bronze', better: 'border-zinc-300', best: 'border-amber-400'}[this.level()]));
}
